import morph from "../helpers/morph";

const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class BlunkOrderList extends HTMLElement {
  constructor() {
    super();
    this.wrapperClass = ".bulk-order-list__wrapper";

    this._modifyCart = debounce(({ method, updates }) => {
      this.querySelector(this.wrapperClass).classList.add("loading");

      window[method](updates, {
        onAfterAdd: () => this._refreshBulkOrderList(),
        onError: () => this._refreshBulkOrderList(),
      });
    }, 150);

    this.addEventListener("click", (e) => {
      if (!e.target.dataset.triggerType) return;

      switch (e.target.dataset.triggerType) {
        case "remove-item":
          this._modifyCart({
            method: "changeCart",
            updates: {
              id: e.target.closest("[data-item-key]").dataset.itemKey,
              quantity: 0,
            },
          });

          break;

        case "remove-all":
          const items = JSON.parse(
            this.querySelector(this.wrapperClass).dataset.cartLineKeys,
          );

          const updateObject = items.reduce((accumulator, currentString) => {
            accumulator[currentString] = 0;
            return accumulator;
          }, {});

          this._modifyCart({
            method: "updateCart",
            updates: {
              updates: updateObject,
            },
          });
          break;
      }
    });

    this.addEventListener("change", (e) => this._handleChange(e.target));
  }

  _handleChange(target) {
    const item = target.closest("[data-item-key]");

    if (!item) return;
    const isInCart = item.dataset.itemInCart === "true";

    this._modifyCart({
      method: isInCart ? "changeCart" : "addToCart",
      updates: {
        id: isInCart ? item.dataset.itemKey : item.dataset.variantId,
        quantity: parseInt(target.value, 10),
      },
    });
  }

  _refreshBulkOrderList() {
    window
      .fetchPageData({
        path: this.dataset.url,
        options: { sectionId: this.dataset.sectionId },
      })
      .then((markup) => this._updateBulkOrderList(markup));
  }

  _updateBulkOrderList(markup) {
    const html = new DOMParser().parseFromString(markup, "text/html");

    const sourceContent = html.querySelector(this.wrapperClass);
    morph(this.querySelector(this.wrapperClass), sourceContent);
  }

  get sectionId() {
    return this.querySelector(this.wrapperClass).dataset.sectionId;
  }
}

if (!customElements.get("bulk-order-list")) {
  customElements.define("bulk-order-list", BlunkOrderList);
}
